"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var styles = require("./ComparisonTitle.css");
var Label_1 = require("../../../../atoms/Label");
var LabelProps_1 = require("../../../../atoms/Label/LabelProps");
var utils_1 = require("../../../../../utils/utils");
var Button_1 = require("../../../../atoms/Button");
var ButtonProps_1 = require("../../../../atoms/Button/ButtonProps");
var ComparisonTitle = /** @class */ (function (_super) {
    __extends(ComparisonTitle, _super);
    function ComparisonTitle() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ComparisonTitle.prototype.render = function () {
        var _this = this;
        return (React.createElement("div", { "data-test-id": this.props.testId, className: [styles.comparisonTitleContainer].join(' ') },
            React.createElement(Label_1.default, { testId: utils_1.default(this.props.testId, 'Label'), data: { text: this.props.data.isCurrentPlan ? this.props.data.currentPlanText : '\b' }, options: { className: styles.dtvCurrentPlan, size: LabelProps_1.LabelSizes.SMALL } }),
            React.createElement(Label_1.default, { testId: utils_1.default(this.props.testId, 'Label'), data: { text: this.props.data.title }, options: { size: this.getLabelSize() } }),
            this.props.data.showButton ?
                React.createElement("div", { className: styles.dtvSeeMoreWrapper },
                    React.createElement(Button_1.default, { data: { text: this.props.data.seePlanDetailsBtnText }, events: { onClick: function () { _this.props.events.planDetailsEvent(_this.props.data.isCurrentPlan); } }, options: {
                            className: styles.dtvTitleLink,
                            role: ButtonProps_1.ButtonRole.LINK,
                            type: ButtonProps_1.ButtonType.TEXT,
                        } })) :
                (React.createElement("div", { className: styles.dtvHidden }, " \u00A0"))));
    };
    ComparisonTitle.prototype.getLabelSize = function () {
        return window.innerWidth < 768 ? LabelProps_1.LabelSizes.LARGE : LabelProps_1.LabelSizes.SMALLHEADING24;
    };
    return ComparisonTitle;
}(React.Component));
exports.default = ComparisonTitle;
//# sourceMappingURL=ComparisonTitle.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/ui-components/components/cards/CardComparisonContainer/components/ComparisonTitle/ComparisonTitle.js
// module id = 1329
// module chunks = 8